import { appendReduxParts } from "infrastructure/store";

import { termTranslationsUploadSaga } from "./components/term-translations-upload/TermTranslationsUpload.saga";
import { termTranslationsUpload } from "./components/term-translations-upload/TermTranslationsUpload.slice";
import TranslationsManager from "./TranslationsManager";
import { translationsManagerSaga } from "./TranslationsManager.saga";
import { translationsManager } from "./TranslationsManager.slice";

export { TranslationsManager };

appendReduxParts(
  [
    {
      reducerName: translationsManager.name,
      reducer: translationsManager.reducer
    },
    {
      reducerName: termTranslationsUpload.name,
      reducer: termTranslationsUpload.reducer
    }
  ],
  [translationsManagerSaga(), termTranslationsUploadSaga()]
);
